/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2021-2022 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

// this is a react component that encapsulates the username and password form .
// It uses the authentactionservice to autheticate with tririga and then
// pushes the session token to the local sessionStorage.

import React from 'react';
import "../login-form/LoginForm.scss";
import {ChangePwdForm} from '../change-pwd-form/ChangePwdForm';
import { AuthenticationService } from '../service/AuthenticationService';

import { Button, Form, TextInput } from 'carbon-addons-iot-react';
import { ArrowRight32 } from '@carbon/icons-react';
import { InlineNotification } from "carbon-components-react";
import { AppMsg } from "../utils";

class LoginForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            isChangePassword: false,
            isPasswordChangeSuccess: false,
            errorMessage: '',
            disableContinue: true,
            height: window.innerHeight
        }
        this.textInputRef = null;
        this.loginObj = this._initLoginObj();
    }

    _initLoginObj() {
        let loginObj = {
            screenDPI: this._initScreenDPI(),
            screenWidth: window.screen.width,
            screenHeight: window.screen.height,
            contentType: "/html/en",
            languageId: 1,
            ieFlag: 0,
        };
        //Get the remaining properties from query parameters.
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let isAdmin = params.get('isAdmin');
        if (isAdmin && isAdmin === 'true') {
            loginObj.isAdmin = true;
        } else {
            loginObj.isAdmin = false;
        }
        let isTririgaUX = params.get('isTririgaUX');
        if (isTririgaUX && isTririgaUX === 'true') {
            loginObj.isTririgaUX = true;
        } else {
            loginObj.isTririgaUX = false;
        }
        loginObj.ExtReqURL = params.get('ExtReqURL');
        loginObj.pageTitle = decodeURIComponent(params.get('pageTitle'));
        loginObj.state = params.get('state');

        return loginObj;
    }

    _initScreenDPI() {
        let screenDPI;
        try {
            screenDPI = window.screen.deviceXDPI;
            if(!screenDPI || screenDPI == 'null' || 
                    screenDPI == 'undefined' ||
                    screenDPI == 0) {
                screenDPI = 96;
            }
        } catch(ex) {
            screenDPI = 96;
        }
        return screenDPI;
    }

    _setUsername(name) {
        this.setState({
            username: name
        }, () => { this._validateInputFields() });
    }

    _setPassword(pwd) {
        this.setState({
            password: pwd
        }, () => { this._validateInputFields() });
    }

    _validateInputFields() {
        //if username and password fields are not empty then enable continue button
        if (this.state.username !== '' && this.state.password !== '' && this.state.errorMessage === '') {
            this.setState({
                disableContinue: false
            });
        } else {
            this.setState({
                disableContinue: true
            });
        }
    }

    _enableContinueButton() {
        this.setState({
            errorMessage: ''
        }, () => { this._validateInputFields() });
    }

    handleSubmit(event) {
        event.preventDefault();
        AuthenticationService.login(this.state.username, this.state.password, this.loginObj).then(
            url => {
                if (this.loginObj.isTririgaUX) {
                    //For UX, url end point is already in place.
                    //Window location reload is same logic previous UX login page used.
                    window.top.location.reload();
                } else {
                    let tririgaUrl = url;
                    if (process.env.NODE_ENV === 'development') {
                        tririgaUrl = process.env.REACT_APP_DEV_HOST + "/.." + url;
                    }
                    window.top.location = tririgaUrl;
                }
            },
            error => {
                let isPasswordChangeRequired = error.includes(AppMsg.getMessage(AppMsg.APP_PASSWORD_CHANGE_REQUIRED));
                this.setState({
                    errorMessage: !isPasswordChangeRequired ? error : '',
                    isChangePassword: isPasswordChangeRequired,
                    disableContinue: true
                });
            }
        );
    }

    _handleAutofill(e) {
        if (e.animationName === "onAutoFillStart") {
            console.log('Auto Fill Detected');
            //This will fail if only user name is filled by browser and empty password
            this._enableContinueButton();
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }
    
    componentWillUnmount(){
        window.removeEventListener('resize', this.handleResize);
    }
    
    handleResize = () => {
       this.setState({height: window.innerHeight});
    };

    showPwdSuccessfulLoginForm = () => {
       this._resetUserStateFromPasswordChange();
    };

    _resetUserStateFromPasswordChange = () => {
        this.setState({
            username: '',
            password: '',
            isChangePassword: false,
            errorMessage: '',
            disableContinue: true,
            isPasswordChangeSuccess: true
        });
    }

    render() {
        return (
            <div>
                {this.state.isChangePassword ? <ChangePwdForm
                    username={this.state.username}
                    showPwdSuccessfulLoginForm={this.showPwdSuccessfulLoginForm.bind(this)}
                    />:
                <div className="login-main-wrapper" style={{ height: this.state.height }} >
                    <div className='login-wrapper'>
                        <div className="login-header">
                            <div>
                                <label>{this.state.isPasswordChangeSuccess ? AppMsg.getMessage(AppMsg.APP_PASSWORD_CHANGE_SUCCESSFUL): '' } 
                                {this.state.isPasswordChangeSuccess ? <br/>: ''}
                                {AppMsg.getMessage(AppMsg.APP_LOG_IN_TO) + ' ' + this.loginObj.pageTitle}</label></div>
                            <div>{this.loginObj.isAdmin ? <label> {AppMsg.getMessage(AppMsg.APP_ADMIN_CONSOLE)}</label> : ''}</div>
                        </div>
                        <hr className='horizontal-line' />
                        <Form onSubmit={this.handleSubmit.bind(this)}>
                            <div>
                                <TextInput
                                    labelText={AppMsg.getMessage(AppMsg.APP_USERNAME)}
                                    id='username'
                                    placeholder="Enter your username"
                                    type="text" value={this.state.username}
                                    onChange={(e) => this._setUsername(e.target.value)}
                                    onAnimationStart={(e) => this._handleAutofill(e)}
                                    ref={element => this.textInput = element} />
                            </div>
                            <div>
                                <TextInput
                                    labelText={AppMsg.getMessage(AppMsg.APP_PASSWORD)}
                                    id='password'
                                    placeholder="Enter your password"
                                    type="password"
                                    onChange={(e) => this._setPassword(e.target.value)} />
                            </div>
                            <div>
                                <Button
                                    kind="primary"
                                    size="field"
                                    renderIcon={ArrowRight32}
                                    onClick={(e) => this.handleSubmit(e)}
                                    type="submit"
                                    disabled={this.state.disableContinue}>
                                    {AppMsg.getMessage(AppMsg.APP_CONTINUE)}
                                </Button>
                            </div>
                        </Form>
                        {this.state.errorMessage ?
                            <div>
                                <InlineNotification
                                    hideCloseButton={false}
                                    iconDescription="close"
                                    kind="error"
                                    notificationType="inline"
                                    onCloseButtonClick={() => this._enableContinueButton()}
                                    role="alert"
                                    statusIconDescription=""
                                    subtitle={this.state.errorMessage}
                                    title="Error" />
                            </div> : ''
                        }
                    </div>
                </div>
                }
            </div>
        );
    }
}

export default LoginForm;